import hyperHTML from 'hyperhtml';

const calculatePresetClasses = (preset, state) => {
  const classes = ['e-daterange__preset'];
  if (state.minDate > preset.start || state.maxDate < preset.end) {
    classes.push('e-daterange__preset-disabled');
  } else if (state.start.value === preset.start && state.end.value === preset.end) {
    classes.push('e-daterange__preset-active');
  }

  return classes.join(' ');
};

const calculateOrder = (preset) => {
  return preset ? preset.order ? `order: ${preset.order};` : '' : '';
};

const presetMap = (state) => Object.keys(state.presets).map((index) => presets(state.presets[index], state));
const presets = (preset, state) => hyperHTML.wire(preset)`
<div
  class="${calculatePresetClasses(preset, state)}"
  data-start="${preset.start}"
  data-end="${preset.end}"
  style="${calculateOrder(preset)}"
 >${preset.name}</div>
`;

const border = (state) => hyperHTML.wire(state, ':border')`
  <div class="e-daterange__border" style="${state.borderStyle}"></div>
`;

const buttons = (events) => hyperHTML.wire(events)`
  <div class="e-buttongroup">
    <button class="e-btn" onmousedown="${events.cancel}">
      <e-translation key="components.daterangePicker.cancelButton"></e-translation>
    </button>
    <button class="e-btn e-btn-primary" onmousedown="${events.apply}">
      <e-translation key="components.daterangePicker.applyButton"></e-translation>
    </button>
  </div>
`;

export default (render, state, events) => {
  render`
    <div class="e-daterange__container">
      <div class="e-daterange__content">
        ${state.presetsHidden ? null : hyperHTML.wire(state, ':presets')`
          <div class="e-daterange__presets" onclick="${events.preset}">
            ${ presetMap(state) }
          </div>`}
        <div class="e-daterange__start">
          <div class="e-daterange__input e-daterange__input-start">
            <label class="e-field__label">
            <e-translation key="components.daterangePicker.startDate"></e-translation>
            </label>
            <input
              class="e-input"
              type="text"
              date-type="start"
              onblur="${events.handleInputChange}"
              value="${state.start.displayedValue}"
            >
          </div>
          <e-calendar
            class="e-daterange__calendar e-daterange__calendar-start"
            type="start"
            date="${state.start.value}"
            range="${state.end.value}"
            startdate="${state.minDate}"
            enddate="${state.maxDate}"
          ></e-calendar>
        </div>
        <div class="e-daterange__end">
          <div class="e-daterange__input e-daterange__input-end">
            <label class="e-field__label">
              <e-translation key="components.daterangePicker.endDate"></e-translation>
            </label>
            <input
              class="e-input"
              type="text"
              date-type="end"
              onblur="${events.handleInputChange}"
              value="${state.end.displayedValue}"
            >
          </div>
          <e-calendar
            class="e-daterange__calendar  e-daterange__calendar-end"
            type="end"
            date="${state.end.value}"
            range="${state.start.value}"
            startdate="${state.start.value}"
            enddate="${state.maxDate}"
          ></e-calendar>
        </div>
      </div>
      <span>${state.layout !== 'inline' ? buttons(events) : ''}</span>
    </div>
    <span>${border(state)}</span>
  `;
};
